import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconMarginTop12 from './IconMarginTop12';
import IconMarginTop16 from './IconMarginTop16';
import IconMarginTop20 from './IconMarginTop20';
import IconMarginTop24 from './IconMarginTop24';
import IconMarginTop32 from './IconMarginTop32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconMarginTop = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconMarginTop12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconMarginTop16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconMarginTop20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconMarginTop24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconMarginTop32 {...props} />}
        </span>
    );
};
IconMarginTop.displayName = 'FondueIconMarginTop';

export default memo(IconMarginTop);
